import { CredentialResponse, GoogleOAuthProvider } from '@react-oauth/google';
import './login.css';
import React, { Dispatch } from 'react'
import { GoogleLogin } from '@react-oauth/google';
import { compareVersions, logInfo } from 'core';
import { getServicesManager } from 'services';
import { CHROME_EXTENSION_ACTIVATE_PAGE, CHROME_EXTENSION_START_PAGE, EXTENSION_ID, MESSAGE_TYPES, MINIMUM_EXTENSION_VERSION_FOR_NEW_LOGIN_FLOW, OAUTHLOGIN_TYPES, SERVICES_HOSTNAME } from 'cfg/endpoints';
import { Alert, AlertProps, AlertType } from 'components/Alert';
import { ATTRIBUTION_CHANNEL_STORAGE_KEY, REFERRER_STORAGE_KEY, TRACKER_TYPE } from 'cfg/sources';
import { getWidth } from 'lib/user-agent';
import { TrackerPayloadParam } from 'interfaces/services';
import { Typography } from 'interfaces/typography';
import { Configuration,  PublicClientApplication } from "@azure/msal-browser";
import { MicrosoftLoginButton } from './MSFTButton';
import { connect } from 'react-redux';
import { RootState } from 'store';
import { AnyAction } from '@reduxjs/toolkit';
import { updateAuthorizationInfo } from 'lib/redux/store';
import { Navigate } from 'react-router-dom';

// MSAL configuration
const configuration: Configuration = {
    auth: {
        clientId: "7a586899-6432-4680-99f4-122a845a4f24",
        authority: "https://login.microsoftonline.com/common",
        redirectUri: `${window.location.origin}${window.location.pathname}`,
        navigateToLoginRequestUrl: true,
    }
};
const pca = new PublicClientApplication(configuration);
pca.initialize()
// Function to sign in

export enum AuthState {
    SIGNIN = 'SIGNIN',
    SIGNUP = 'SIGNUP',
    PASSWORD_RESET_REQUEST = 'PASSWORD_RESET_REQUEST',
    PASSWORD_RESET = 'PASSWORD_RESET'
}

export type LoginState = {
    authState: AuthState
    showAlert: boolean
    alertProps?: AlertProps
    
    name?: string,
    email?: string,
    password?: string,
    recovery_code?: string,

    extensionId?: string,
    extensionVersion?: number[]
}

const TrellusLogo = <svg width="180" height="50" viewBox="0 0 180 50" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M71.9614 19.6378V14.5123H66.4014V40.2352H71.9614V26.7936C72.1151 25.3107 72.5661 24.0214 73.3157 22.9173C74.0567 21.8131 75.0725 20.967 76.3459 20.387C77.627 19.7988 79.1259 19.5491 80.8584 19.6378V14.3184C78.8199 14.3184 77.047 14.7703 75.54 15.6723C74.0329 16.5678 72.84 17.8888 71.9614 19.6378ZM56.0873 8.41998H50.5754V15.4793H46.9492V19.6378H50.5754V30.9815C50.5754 36.0715 54.7395 40.2352 59.8291 40.2352H61.2747V34.7233H60.0173C57.8558 34.7233 56.0873 32.9543 56.0873 30.7933V19.6382H62.2593V15.4797H56.0873V8.41998V8.41998ZM104.223 18.4285C103.249 17.1071 101.959 16.0917 100.355 15.3823C98.7516 14.6811 96.8174 14.3271 94.5611 14.3184C92.6424 14.3353 90.8942 14.6651 89.3066 15.294C87.7191 15.9229 86.3492 16.8171 85.197 17.9693C84.0366 19.1219 83.1416 20.5 82.5135 22.0953C81.8851 23.6911 81.5622 25.4718 81.5544 27.422C81.5626 29.3641 81.8773 31.1287 82.4971 32.7163C83.1182 34.3039 84.0042 35.6737 85.1568 36.8259C86.3094 37.9785 87.6953 38.8649 89.3071 39.486C90.9193 40.1062 92.7155 40.4205 94.7065 40.4287C96.9386 40.4205 98.9533 40.0413 100.75 39.2839C102.547 38.5351 104.078 37.463 105.344 36.0771L102.394 32.934C101.444 33.9091 100.347 34.6506 99.1148 35.1583C97.8817 35.6737 96.5516 35.9321 95.1415 35.9321C93.7798 35.9239 92.5545 35.666 91.4586 35.1422C90.371 34.6268 89.4521 33.8931 88.7184 32.934C87.9775 31.9749 87.4615 30.8305 87.1633 29.5009H106.601C106.77 27.1719 106.665 25.0766 106.278 23.215C105.891 21.3457 105.206 19.7503 104.223 18.4285ZM87.0659 25.4397C87.2836 24.0616 87.7269 22.8774 88.396 21.8859C89.0725 20.8865 89.9351 20.1212 90.9912 19.5811C92.0464 19.0414 93.2475 18.7752 94.6087 18.7674C96.0192 18.7752 97.2441 19.0414 98.2915 19.5729C99.3394 20.1048 100.161 20.8705 100.757 21.8616C101.362 22.8528 101.692 24.0456 101.765 25.4397H87.0659ZM150.916 27.1805C150.916 28.3085 150.755 29.3563 150.441 30.315C150.126 31.2819 149.659 32.1203 149.054 32.8457C148.45 33.5629 147.709 34.1351 146.839 34.5467C145.968 34.957 144.969 35.1747 143.857 35.2072C142.608 35.1989 141.544 34.9488 140.65 34.4493C139.755 33.9498 139.07 33.2322 138.587 32.306C138.111 31.3789 137.869 30.2665 137.861 28.9698V14.5123H132.3V30.5167C132.309 32.5717 132.688 34.3368 133.437 35.8192C134.186 37.2938 135.258 38.4299 136.66 39.2198C138.071 40.0175 139.754 40.4205 141.729 40.4287C143.841 40.4122 145.686 39.9859 147.249 39.1393C148.812 38.301 150.037 36.9878 150.916 35.2072V40.2352H156.477V14.5123H150.916V27.1805H150.916ZM179.258 29.4606C178.774 28.5668 178.121 27.8332 177.316 27.2528C176.51 26.6806 175.623 26.2045 174.656 25.8345C173.681 25.464 172.714 25.1415 171.747 24.8593C170.78 24.5853 169.885 24.2949 169.071 24.0049C168.265 23.7072 167.613 23.3444 167.121 22.9168C166.629 22.4974 166.38 21.9503 166.364 21.2816C166.372 20.6683 166.533 20.1771 166.856 19.7984C167.177 19.4196 167.629 19.1457 168.193 18.9764C168.758 18.799 169.402 18.7185 170.135 18.7185C170.9 18.7185 171.706 18.8159 172.561 18.9925C173.407 19.1781 174.261 19.4352 175.107 19.7741C175.962 20.1122 176.767 20.5233 177.533 20.9912L179.563 16.8812C178.782 16.3328 177.903 15.8575 176.92 15.4706C175.937 15.0841 174.906 14.7859 173.826 14.5846C172.746 14.3751 171.658 14.2704 170.571 14.2704C169.33 14.2704 168.137 14.4072 167.009 14.6976C165.881 14.988 164.873 15.4308 163.987 16.035C163.093 16.6396 162.4 17.4049 161.884 18.348C161.368 19.2907 161.102 20.4112 161.094 21.7166C161.103 23.0298 161.344 24.1261 161.828 25.0043C162.311 25.8829 162.948 26.6001 163.746 27.1563C164.544 27.712 165.43 28.163 166.381 28.5179C167.34 28.872 168.299 29.1871 169.258 29.4606C170.217 29.7346 171.103 30.025 171.901 30.3388C172.706 30.6535 173.351 31.04 173.835 31.5079C174.318 31.9749 174.568 32.5791 174.584 33.3205C174.576 33.9654 174.39 34.4891 174.02 34.8916C173.649 35.3028 173.149 35.601 172.521 35.7945C171.892 35.9797 171.175 36.0767 170.377 36.0767C169.427 36.0767 168.435 35.9473 167.395 35.6893C166.356 35.4314 165.341 35.0691 164.365 34.5934C163.391 34.1182 162.528 33.546 161.771 32.8855L159.788 36.8497C160.651 37.6236 161.65 38.2763 162.77 38.8078C163.898 39.3397 165.091 39.7427 166.348 40.0167C167.605 40.2911 168.871 40.4278 170.136 40.4278C171.442 40.4278 172.683 40.2746 173.859 39.9764C175.036 39.67 176.091 39.2107 177.01 38.5819C177.929 37.9616 178.654 37.1644 179.186 36.2048C179.718 35.2457 179.991 34.1017 180 32.7877C179.991 31.4676 179.749 30.3557 179.258 29.4606ZM110.537 40.2352H116.098V4.3584H110.537V40.2352ZM121.827 40.2352H127.387V4.3584H121.827V40.2352Z" fill="black"/>
<path fillRule="evenodd" clipRule="evenodd" d="M26.2535 16.0368C26.2548 17.2236 26.2535 18.3853 26.2535 19.5721C28.7916 19.85 31.3296 20.1382 33.8677 20.4157C33.8698 22.7226 33.8677 21.2268 33.872 23.8423C33.8724 24.6006 33.3093 25.3524 32.4476 25.3325C29.8827 25.2658 27.3161 25.2104 24.7503 25.1507C24.7387 21.0536 24.7425 16.9557 24.7378 12.8591C24.7365 9.47312 21.4665 6.47671 18.2096 5.51888C12.1237 3.7283 6.08501 1.79317 0 0C0 2.93538 0 5.87119 0 8.80657C0 14.1692 5.67556 17.4474 10.7655 18.0126C14.0433 18.3762 17.3275 18.5909 20.6048 18.9458C20.6061 20.9826 20.6083 23.0186 20.6091 25.055C19.3241 25.0256 18.0395 24.9962 16.7553 24.9663C12.7803 24.8707 8.37332 27.5559 8.37419 31.5906C8.37722 37.4471 8.38284 43.304 8.38284 49.1609C11.6675 48.1979 14.9535 47.2323 18.2377 46.2671C21.4847 45.3149 24.7646 42.3085 24.7607 38.9325C24.7603 37.2125 24.7573 35.164 24.756 33.4444C24.7555 32.4121 24.7547 31.3798 24.7547 30.3484C23.374 30.4168 21.9924 30.3796 20.6117 30.4475C20.6117 33.2202 20.6173 36.3235 20.6173 39.0966C20.6173 40.5262 19.5578 42.0029 18.0408 42.376C16.654 42.718 15.2677 43.059 13.8818 43.4005C13.8814 39.3688 13.8758 35.3362 13.874 31.305C13.8732 29.9264 15.4053 28.9781 16.7562 28.9482C21.9868 28.8201 27.2191 28.6938 32.4498 28.5674C35.0294 28.5072 36.7836 26.2998 36.7801 23.9708C36.7771 21.8833 36.7767 19.7937 36.7715 17.7062C33.2656 17.1522 29.7602 16.5895 26.2535 16.0368ZM10.8646 13.5953C8.57458 13.2326 6.99393 12.086 6.99393 9.77479C6.99393 8.74814 6.99349 7.72193 6.99349 6.69615C10.6681 7.60117 14.341 8.50879 18.0148 9.41425C19.2557 9.72026 20.5979 11.0135 20.5983 12.2981C20.6018 13.3005 20.6018 14.1385 20.6026 15.14C17.3569 14.625 14.1103 14.1099 10.8646 13.5953Z" fill="#5DD077"/>
</svg>

const _LOG_SCOPE = '[Trellus][External signin]'

type LoginProps = {
    viewState?: AuthState
    viaMainPage?: boolean
    dispatch: Dispatch<AnyAction>
}


class AuthenticationImpl extends React.Component<LoginProps, LoginState> {
    constructor(props: LoginProps) {
        const email = new URLSearchParams(window.location.search).get('email')
        const recovery_code = new URLSearchParams(window.location.search).get('recovery_code')
        
        super(props)
        this.state = {
            'authState': props.viewState ??AuthState.SIGNIN,
            'showAlert': false,
            'email': email ?? undefined,
            'recovery_code': recovery_code ?? undefined,
        }
    }

    _onExtensionMessageBounded = this._onExtensionMessage.bind(this)

    componentDidMount(): void {
        logInfo('registering event listener')
        window.addEventListener('message', this._onExtensionMessageBounded)
      }

    componentWillUnmount(): void {
        logInfo('unregistering event listener')
        window.removeEventListener('message', this._onExtensionMessageBounded)
    }

    _onExtensionMessage (event: any) {
        const message = event.data
        logInfo(`${_LOG_SCOPE} Receiving message type ${message['type']}`)
        switch (message['type']) {
          case MESSAGE_TYPES.APP_TO_EXTERNAL_SET_EXTENSION_INFO:
            const extensionId = message['extensionId']
            if (message['extensionVersion']) {
                const extensionVersion: number[] = message['extensionVersion'].split('.').map((x: string) => {return parseInt(x)})
                logInfo(`${_LOG_SCOPE} Extension version is ${extensionVersion}`)
                this.setState({'extensionVersion': extensionVersion})
            }
            this.setState({'extensionId': extensionId})
            break
          case MESSAGE_TYPES.APP_TO_EXTERNAL_CHECK_IS_LOADED:
            window.postMessage({'type': MESSAGE_TYPES.EXTERNAL_TO_APP_IS_LOADED})
            break
          default:
            logInfo(`${_LOG_SCOPE} Skipping message of type ${message['type']}`)
            break
        }
    }

    /**
     * Sign up the user and store the resulting api key in local storage
     */
    async _passwordSignInUser () {
        // make the request
        if (!this.state.email || !this.state.password){
            this._addAlert('Please fill out all fields', false)
            return
        } 

        // make the request
        logInfo(`${_LOG_SCOPE} Forming signin user request`)
        const authResult = await getServicesManager().passwordLogin(this.state.email, this.state.password)
        if (authResult == null) {
            logInfo(`${_LOG_SCOPE} Invalid user signin response`)
            this._addAlert('Invalid credentials...please try again', false) 
        } else {
            logInfo(`${_LOG_SCOPE} Got valid auth response from password signin`)
            this._setApiKey.bind(this)(authResult.apiKey)
        }
    }

    /**
     * Sign up the user and store the resulting api key in local storage
     */
    async _passwordSignupUser () {
        // make the request
        if (!this.state.email || !this.state.name || !this.state.password){
            this._addAlert('Please fill out all fields', false)
            return
        } 
        // make the request
        logInfo(`${_LOG_SCOPE} Forming signup user request`)
        const authResult = await getServicesManager().passwordSignup(this.state.name, this.state.email, this.state.password)
        if (authResult == null) {
            logInfo(`${_LOG_SCOPE} Invalid user signup response`)
            this._addAlert('Error signing up...please try again', false) 
        } else {
            logInfo(`${_LOG_SCOPE} Got valid user signup response from google oauth`)
            this._setApiKey.bind(this)(authResult.apiKey)
        }
  }

  async _resetPasswordUser() {
    if (!this.state.email || !this.state.password || !this.state.recovery_code) {
        this._addAlert('Please ensure all fields/url are correct')
        return
    }

    // make the request
    logInfo(`${_LOG_SCOPE} Forming password request`)    
    const authResult = await getServicesManager().resetPassword(this.state.email, this.state.recovery_code, this.state.password)
    if (authResult == null) {
        logInfo(`${_LOG_SCOPE} Invalid password reset`)
        this._addAlert('Error resetting password...please try again', false) 
    } else {
        logInfo(`${_LOG_SCOPE} Got valid user signup response from google oauth`)
        this._setApiKey.bind(this)(authResult.apiKey)
    }
  }

  async update_local_storage(apiKey: string) {
        let hasChrome = false
        try { hasChrome = chrome != null && chrome.runtime != null
        } catch (e) { }
        const api_info = {'apiKey': apiKey, 'services': SERVICES_HOSTNAME, 'has_extension': hasChrome}
        getServicesManager().updateApiInfo(api_info)
        this.props.dispatch(updateAuthorizationInfo({'value': {'apiKey': apiKey, 'services': SERVICES_HOSTNAME, 'has_extension': hasChrome}}))
        await this._submitTrackerInformation(apiKey)
        return true
  }

    async _submitTrackerInformation(apiKey: string) {
        // make the request
        logInfo(`${_LOG_SCOPE} Submitting tracking information`)
        const trackerPayloads: TrackerPayloadParam = []
        const referrer = window.localStorage.getItem(REFERRER_STORAGE_KEY)
        const attributionChannel = window.localStorage.getItem(ATTRIBUTION_CHANNEL_STORAGE_KEY)
        if (referrer !== null) trackerPayloads.push({'payload_key': REFERRER_STORAGE_KEY, 'payload_value': referrer})
        if (attributionChannel !== null) trackerPayloads.push({'payload_key': ATTRIBUTION_CHANNEL_STORAGE_KEY, 'payload_value': attributionChannel})
        const baseUrl = window.location.hostname
        const result = getServicesManager().submitTrackers(baseUrl, TRACKER_TYPE.INSTALL, trackerPayloads, apiKey)
        if (result == null) {
            logInfo(`${_LOG_SCOPE} Tracking information not properly submitted`)
        }
        //clear up parameters
        window.localStorage.removeItem(REFERRER_STORAGE_KEY)
        window.localStorage.removeItem(ATTRIBUTION_CHANNEL_STORAGE_KEY)
  }

  _constructStartPage(extensionId: string) {
    return 'chrome-extension://' + extensionId + '/start_page.html'
  }

  _constructDialerActivation(extensionId: string) {
    return 'chrome-extension://' + extensionId + '/pages/activate_dialers.html'
  }

  _redirectBasedOfPageWidth() {
    if (this.props.viaMainPage) {
        window.location.href = '/'
        return
    }
    window.location.replace(this.state.extensionId ? this._constructDialerActivation(this.state.extensionId) : CHROME_EXTENSION_ACTIVATE_PAGE)
    }

    _closeAlert() {
        this.setState({'showAlert': false, 'alertProps': undefined})
    }

    _addAlert(label: string, isSuccess?: boolean, time?: number) {
        this.setState({'showAlert': true, alertProps: {'alertType': AlertType.STANDARD, 'bgColorTailwind': isSuccess ? 'bg-green-800' : 'bg-red-800',  onCloseOrNo: this._closeAlert.bind(this), stringToShow: label}}, 
        () => setTimeout(() => this._closeAlert.bind(this)(), time ?? 5000))
    }

    _setApiKey(apiKey: string) {
        let hasChrome = false
        try { hasChrome = chrome != null && chrome.runtime != null
        } catch (e) { }

        if (!hasChrome) {
            if (this.props.viaMainPage) {
                this.update_local_storage(apiKey).then(() => this._redirectBasedOfPageWidth())
            }
            else {
                this._addAlert('You must have the extension installed here to ensure access', false, 10000)
                return
            }
        } else {
            chrome.runtime.sendMessage(this.state.extensionId ?? EXTENSION_ID, {
                'type': MESSAGE_TYPES.EXTERNAL_TO_BACKGROUND_SET_API_KEY, 
                'apiKey': apiKey, 
            }, {}, (result) => {
                // update the status. 
                // note: it would be cleaner to await this as a promise instead of using a callback
                //  but that seemed not to work for me
                if (result == null)
                    this._addAlert('Server did not response', false)
                else if (result === true || result['success'] === true)
                    this.update_local_storage(apiKey).then(() => this._redirectBasedOfPageWidth())
                else if (result['error'] != null)
                    this._addAlert(`Error: ${result['error']}`, false)
                else if (result['success'] === false)
                    this._addAlert('Server roundtrip failed', false)
                else
                this._addAlert('Unkown error', false)
            });
            }
        }
  
    async _handleMSFTLogin() {
        let idToken = null
        try {
            const loginResponse = await pca.loginPopup();
            idToken = loginResponse && loginResponse.idToken ? loginResponse.idToken : idToken
          } catch (error) {
        }
        // make the request
        logInfo(`${_LOG_SCOPE} Forming signup user request with oauth`)
        if (!idToken) {
            this._addAlert('Error logging in with microsoft...please try again', false) 
            return
        }
        const authResult = await getServicesManager().oauthLogin(idToken, OAUTHLOGIN_TYPES.MICROSOFT_LOGIN)
        if (authResult == null) {
            logInfo(`${_LOG_SCOPE} Invalid user signup response`)
            this._addAlert('Error logging in with microsoft...please try again', false) 
        } else {
            logInfo(`${_LOG_SCOPE} Got valid user signup response from microsoft oauth`)
            this._setApiKey.bind(this)(authResult.apiKey)
        }
    }   

    async _handleGoogleCredentialResponse(credential: CredentialResponse) {
        // make the request
        logInfo(`${_LOG_SCOPE} Forming signup user request with oauth`)
        if (!credential.credential) {
            this._addAlert('Error logging in with google...please try again', false) 
            return
        }
        const authResult = await getServicesManager().oauthLogin(credential.credential, OAUTHLOGIN_TYPES.GOOGLE_LOGIN)
        if (authResult == null) {
            logInfo(`${_LOG_SCOPE} Invalid user signup response`)
            this._addAlert('Error logging in with google...please try again', false) 
        } else {
            logInfo(`${_LOG_SCOPE} Got valid user signup response from google oauth`)
            this._setApiKey.bind(this)(authResult.apiKey)
        }
    }


    _renderCTAButton(call_to_action: string, onClick: () => {}): JSX.Element {
        return <div onClick={onClick.bind(this)} className='cursor-pointer p-4 w-full text-center flex flex-row justify-center items-center opacity-85 hover:opacity-100' 
        style={{'borderRadius': '5px', 'border': '1px solid #5DCF77', 'backgroundColor': '#EFFAF1'}}>
            <Typography variant='largeParagraph' fontSize={"15px"}>
                {call_to_action}
            </Typography>
        </div>
    }

  _renderSigninForm(): JSX.Element {
    return (
        <div className="flex flex-col w-1/2 gap-2">
            <input className='inputField' onChange={(e) => this.setState({'email': e.target.value})} value={this.state.email ?? ''} type={'email'} placeholder={'Email'} contentEditable={true} />
            <input className='inputField' onChange={(e) => this.setState({'password': e.target.value})} value={this.state.password ?? ''} type={'password'} placeholder={'Password'} contentEditable={true} />
            {this._renderCTAButton('Sign in', this._passwordSignInUser.bind(this))}
        </div>)
  }

  _renderSignupForm(): JSX.Element {
    return (
    <div className="flex flex-col w-1/2 gap-2">
        <input className='inputField' onChange={(e) => this.setState({'name': e.target.value})} value={this.state.name ?? ''}  type={'name'} placeholder={'Name'} contentEditable={true} />
        <input className='inputField' onChange={(e) => this.setState({'email': e.target.value})} value={this.state.email ?? ''}  type={'email'} placeholder={'Email'} contentEditable={true} />
        <input className='inputField' onChange={(e) => this.setState({'password': e.target.value})} value={this.state.password ?? ''} type={'password'} placeholder={'Password'} contentEditable={true} />
        {this._renderCTAButton('Sign up', this._passwordSignupUser.bind(this))}
    </div>)
  }

  _renderPasswordResetForm(): JSX.Element {
    return (
        <div className="flex flex-col w-1/2 gap-2">
            <input className='inputField' onChange={(e) => this.setState({'password': e.target.value})} value={this.state.password ?? ''} type={'password'} placeholder={'Password'} contentEditable={true} />
            {this._renderCTAButton('Reset Password', this._resetPasswordUser.bind(this))}
        </div>)
    }

  _renderInputForm(): JSX.Element | null{
    return (
        this.state.authState === AuthState.SIGNIN ? this._renderSigninForm() : this.state.authState === AuthState.SIGNUP ? this._renderSignupForm() : this.state.authState === AuthState.PASSWORD_RESET ? this._renderPasswordResetForm() : null
    )
  }

  _renderBottomCTA(): JSX.Element {
    return (
    <div className='flex flex-row gap-2 items-center'  style={{"color": "black"}}>
    <span id="sign-in-type-text">{this.state.authState === AuthState.SIGNIN ? 'No account?' : 'Have an account?'}</span> 
    <span id="sign-in-type-button" onClick={() => this.setState((state) => {return {'authState': state.authState === AuthState.SIGNIN ? AuthState.SIGNUP : AuthState.SIGNIN, 'email': undefined, 'name': undefined, 'password': undefined}})} style={{"textDecoration": "none", "color": "black", "fontWeight": "bold", "cursor": "pointer"}}>
        {this.state.authState === AuthState.SIGNIN ? 'Sign up' : 'Sign in'}
    </span>
    </div>)
  }

  _renderPasswordResetCTA(): JSX.Element | null {
    if (this.state.authState !== AuthState.SIGNIN) return null
    return (
    <div className='flex flex-row gap-2 items-center'  style={{"color": "black"}}>
    <span id="sign-in-type-text">{"Forgot password?"}</span> 
    <span id="sign-in-type-button" onClick={() => this.setState((state) => {return {'authState': AuthState.PASSWORD_RESET_REQUEST, 'email': undefined}})} style={{"textDecoration": "none", "color": "black", "fontWeight": "bold", "cursor": "pointer"}}>
        {'Reset password'}
    </span>
    </div>)
  }


  _renderTermsAndService(): JSX.Element {
    return (
        <div className='w-full flex flex-row items-center justify-center gap-1'>
            <Typography variant='caption' color='black'>
                By using Trellus you agree to the following 
            </Typography>
            <a href='https://www.trellus.ai/terms' target={'_blank'} rel="noreferrer">
            <Typography variant='caption' color='black' className='hover:text-slate-400' style={{'textDecoration': 'underline'}}>
                terms
            </Typography>
            </a>
        </div>
    )
  }

  renderLoginOrSignupPage(): JSX.Element | null {
    if (![AuthState.SIGNIN, AuthState.SIGNUP].includes(this.state.authState)) return null
    return (
        <div className='flex flex-col justify-center w-full items-center gap-5'>
        <div className="flex justify-center items-center">  
        <GoogleLogin
            onSuccess={(credentialResponse: CredentialResponse) => this._handleGoogleCredentialResponse.bind(this)(credentialResponse)}
            onError={() => this._addAlert.bind(this)('Google login failed', false)}
        />
    </div>
    <MicrosoftLoginButton onClick={this._handleMSFTLogin.bind(this)}/>
        
    <div style={{"color": "lightgrey"}}>
    or
    </div>
    {this._renderInputForm()}
    {this._renderBottomCTA()}
    {this._renderPasswordResetCTA()}
    {this._renderTermsAndService()}
    </div>
    )
  }

  async requestPasswordRestEmail() {
    if (!this.state.email) return null
    const result = await getServicesManager().requestPasswordResetEmail(this.state.email)
    this._addAlert(result ? 'Check your email for a password reset email' : 'No user with that email address found - try again', result, 8000)
  }

  renderPasswordResetRequest(): JSX.Element | null {
    if (this.state.authState !== AuthState.PASSWORD_RESET_REQUEST) return null
    return <div className='flex flex-col justify-center w-full items-center gap-5'>
            <div className="flex flex-col w-1/2 gap-2">
                <input className='inputField' onChange={(e) => this.setState({'email': e.target.value})} value={this.state.email ?? ''}  type={'email'} placeholder={'Email'} contentEditable={true} />
                {this._renderCTAButton('Request password', this.requestPasswordRestEmail.bind(this))}
            </div>

            <div className='flex flex-row gap-2 items-center'  style={{"color": "black"}}>
            <span id="sign-in-type-text">{"Return to login?"}</span> 
            <span id="sign-in-type-button" onClick={() => this.setState((state) => {return {'authState': AuthState.SIGNIN}})} style={{"textDecoration": "none", "color": "black", "fontWeight": "bold", "cursor": "pointer"}}>
                {'Login page'}
            </span>
            </div>
    </div>
  }

  renderPasswordReset(): JSX.Element | null {
    if (![AuthState.PASSWORD_RESET].includes(this.state.authState)) return null
    return (
        <div className='flex flex-col justify-center w-full items-center gap-5'>
            {this._renderInputForm()}
            {this._renderBottomCTA()}
            {this._renderPasswordResetCTA()}
            {this._renderTermsAndService()}
    </div>
    )
  }

  render(): JSX.Element {
    return (
    <GoogleOAuthProvider clientId='50226627522-ekkero1qdgs8glk3t809ice0ld8h4i2n.apps.googleusercontent.com'>
        <div className="flex flex-col h-screen w-screen p-5">
        {this.state.showAlert && this.state.alertProps ? 
        <div className='relative'>
            <div className='absolute top-0 left-0 w-full'>
                <Alert {...this.state.alertProps}/>
        </div>
        </div>: null}
        <div className="flex flex-col justify-center m-auto max-w-full items-center gap-5" style={{
            "height": '85%',
            "minWidth": "60%", "width": "800px", "backgroundColor": "white", "borderRadius": "5px", 'border': '1px solid black'}}>
            <div className='h-1/6 flex justify-center'>
                {TrellusLogo}
            </div>
            {[AuthState.SIGNIN, AuthState.SIGNUP].includes(this.state.authState) ? this.renderLoginOrSignupPage() : 
            this.state.authState === AuthState.PASSWORD_RESET_REQUEST ? 
            this.renderPasswordResetRequest() : this.state.authState === AuthState.PASSWORD_RESET ? this.renderPasswordReset(): null}
        </div>
    </div>
    </GoogleOAuthProvider>
    

    )
  }
}

  const mapStateToProps = (state: RootState) => {
    return {};
  };
  
  const ReduxWrapped = connect(mapStateToProps)(AuthenticationImpl)
  
  export { ReduxWrapped as Authentication}